// extracted by mini-css-extract-plugin
module.exports = {"paginatorContainer":"Paginator_paginatorContainer__N1Si8","paginatorItem":"Paginator_paginatorItem__2j1bR","isActive":"Paginator_isActive__37FMv"};